<template>
    <div v-loading="dataLoading">
        <el-card header="演出信息">
            <template v-if="data">
                <el-link :href="`${sswap}/pages/activity/detail/detail?activityId=${data.activityId}`" target="_blank" type="primary">{{ data.title
                }}</el-link>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">演出ID：</label>{{ data.activityId }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">抖音商品ID：</label>{{ data.douyinPoiId }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">开演时间：</label>{{ data.startTime }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">总票数：</label>{{ data.totalTicket }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">售票数：</label>{{ data.sellTicket }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">场地：</label>{{ data.cityName }} {{ data.siteName }}
                    </el-col>
                </el-row>
            </template>
        </el-card>
        <el-card class="MT20">
            <div slot="header">
                <span>通用计划基础信息</span>
                <div v-if="data">
                    <el-button type="text" icon="el-icon-edit" @click="$refs.cpsEdit.show(data)">修改基本信息</el-button>
                    <el-button type="text" icon="el-icon-time" @click="$refs.updateLog.show(data.id)">查看修改历史</el-button>
                </div>
            </div>
            <template v-if="data">
                <el-row :gutter="20">
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">内容形式：</label>{{ contentType[data.contentType] }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">佣金比例：</label>{{ data.ratio }}%
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">计划ID：</label>{{ data.cpsId }}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <label class="color-info">计划状态：</label>{{ status[data.status] }}
                        <el-button v-if="data.status != 3" type="text" icon="el-icon-edit" size="small" @click="$refs.statusEdit.show(data)">修改状态</el-button>
                    </el-col>
                </el-row>
            </template>
        </el-card>
        <el-card class="MT20">
            <div slot="header">
                <span>当前计划汇总数据</span>
                <div v-if="data">
                    数据更新时间：{{data.date}}
                </div>
            </div>
            <template v-if="data">
                <el-row :gutter="20">
                    <el-col :md="8" class="MT10">
                        <label class="color-info">带货总销售额：</label>{{ data.gmv }}
                    </el-col>
                    <el-col :md="8" class="MT10">
                        <label class="color-info">达人佣金：</label>{{ data.talentCommission }}
                    </el-col>
                    <el-col :md="8" class="MT10">
                        <label class="color-info">已核销订单金额：</label>{{ data.usedGmv }}
                    </el-col>
                </el-row>
            </template>
        </el-card>
        <el-card class="MT20">
            <div slot="header">
                <span>达人列表 <span class="color-info">(达人总数：{{userData && userData.totalUser || 0}})</span></span>
                <div v-if="userData">
                    数据更新时间：{{userData.date}}
                </div>
            </div>
            <div class="page-btns-box">
                <el-button
                    v-if="$utils.have('/activity/cps/downloadUserList')"
                    type="primary"
                    icon="el-icon-download"
                    @click="download"
                    size="small"
                    :loading="downLoading"
                    >导出达人带货数据</el-button
                >
            </div>
            <div class="page-list-box">
                <el-table :data="userList" border style="width: 100%" size="small" stripe>
                    <el-table-column prop="name" label="达人昵称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="douyinId" label="达人抖音ID"></el-table-column>
                    <el-table-column prop="gmv" label="带货销售额"></el-table-column>
					<el-table-column prop="talentCommission" label="带货总佣金"></el-table-column>
					<el-table-column prop="usedGmv" label="已核销 GMV"></el-table-column>
					<el-table-column prop="contributeNum" label="作品数"></el-table-column>
					<el-table-column prop="playNum" label="作品总观看数"></el-table-column>
                    <el-table-column prop="contentType" label="带货场景">
                        <template slot-scope="{row} = scope">
                            {{contentType[row.contentType]}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button
                                v-if="$utils.have('/activity/cps/userDetailList')"
                                type="text"
                                size="small"
                                @click="$refs.userDetailList.show(id,scope.row)"
                                >查看详细数据</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="userData && userData.list" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="getUserList"
                    :current-page.sync="params.pageNo"
                    :page-sizes="$pageSizes"
                    :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="userData.list.totalCount || 0">
                </el-pagination>
            </div>
        </el-card>
        <cps-edit ref="cpsEdit" @onUpdate="getDetailData"></cps-edit>
        <update-log ref="updateLog"></update-log>
        <status-edit ref="statusEdit" @onUpdate="getDetailData"></status-edit>
        <user-detail-list ref="userDetailList"></user-detail-list>
    </div>
</template>
<script>
import CpsEdit from  "./components/CpsEdit.vue"
import UpdateLog from "./components/UpdateLog.vue"
import StatusEdit from "./components/StatusEdit.vue"
import UserDetailList from "./components/UserDetailList.vue"
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{
        CpsEdit,UpdateLog,StatusEdit,UserDetailList
    },
    data() {
        return {
            data: null,
            dataLoading: false,
            sswap: process.env.VUE_APP_SSWAP_URL,
            userData:null,
            userList: [],
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            downLoading: false
        }
    },
    computed: {
        status() {
            return {
                1: '进行中', 2: '暂停中', 3: '已结束'
            }
        },
        contentType() {
            return {
                1: '仅短视频', 2: '仅直播间', 3: '短视频和直播间'
            }
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
            this.getUserList();
        }
    },
    methods: {
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/cps/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 获取达人列表
        getUserList(){
            this.$request({
                url: "/activity/cps/userList",
                method: "POST",
                params: {
                    id: this.id,
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.userData = result;
                        this.userList = result.list && result.list.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getUserList();
        },
        //导出
        download(){
            this.downLoading = true;
            this.$request({
                url: "/activity/cps/downloadUserList",
                method: "POST",
                params: {
                    activityId: this.id,
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>
.el-card__header {
    >div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-button--text {
            padding: 0;
            font-size: 12px;
        }
    }
}
</style>